<script>
    export default {
        name: 'HumanFirewall',
    }
</script>

<template>
    <div>
        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>


// WEBPACK FOOTER //
// Root.vue?221edde6